
export class Gallery {
	constructor(elem) {
		this.elem = elem;
		// Parse settings from element
		this.preload = elem.dataset.preload ?? true
		this.page = 0
		this.size = elem.dataset.size ?? 20
		this.county = elem.dataset.county ?? false;
		this.ages = elem.dataset.ages ?? false;
		this.tag = elem.dataset.tag ?? false;
		this.scroll = elem.dataset.scroll === '1' ? true : false;
		this.lastSort = false;
		this.query = '';
		this.filters = {age: [], county: [], theme: [], medium: [], technique: [], genre: [], sort: 'latest'};
		
		// Initialise state
		this.loading = false
		this.end = false

		this.updateFiltersFromUrl()

		if (this.preload && this.scroll) {
			// Populate the gallery with the next page automatically
			// Useful for the big galleries
			this.loadNextPage()
		}
		
		if (this.scroll) {
			window.addEventListener('scroll', e => {
				this.handleScroll(e)
			})	
		}

		// window.loadSingle = this.loadSingle;
		window.filter = (options) => {
			return this.filter(options)
		};
		window.search = (q) => {
			return this.search(q)
		};
		window.sort = (sort) => {
			sort = JSON.parse(JSON.stringify(sort))
			if (Array.isArray(sort)) {
				sort = sort[0]
			}
			if (this.lastSort === false) {
				this.lastSort = sort;
				return
			}
			if (this.lastSort === sort) {
				return;
			} else {
				this.filters.sort = sort;
				this.lastSort = this.filters.sort
			}
			this.filter(this.filters)
		}
	}
	
	handleScroll(event) {
		// Load the next page if we are within 800 px of scrolling past our 
		// element. Picked a bit at random but makes the site feel more fluid
		const offset = 800
		const triggerHeight = this.elem.offsetTop + this.elem.offsetHeight - offset
		const scrollFrame = window.scrollY + window.innerHeight
		if (scrollFrame > triggerHeight) {
			this.loadNextPage()
		}
	}

	
	async loadNextPage(isFilter = false) {
		console.log('next')
		if (this.loading || this.end) {
			return
		}
		
		this.loading = true
		this.page += 1
		
		let protocol = window.tiaHost.startsWith('//') ? 'http:' : '';
		let path = window.location.href.split(window.tiaHost+'/')[1];
		let endpoint = new URL(`${protocol}${window.tiaHost}/tia/${path}`);
		let data = {
			page: this.page,
			size: this.size,
			sort: this.filters.sort,
		}
		for (let k in data) {
			endpoint.searchParams.append(k, data[k]);
		}
		for (const k in this.filters) {
			endpoint.searchParams.append(k, this.filters[k])
		}
		if (isFilter) {
			endpoint.searchParams.append('fresh', true)
		}
		const response = await fetch(endpoint)
		if (response.ok) {
			const result = await response.text()
			if (isFilter) {
				this.elem.innerHTML = ''
			}
			this.elem.innerHTML += result
			window.dispatchEvent(new Event('imageReload'));
			const errorElem = this.elem.querySelector('empty-results-error')
			if (errorElem) {
				errorElem.remove()
			}
			this.loading = false;
		} else {
			// Hit the end of the dataset
			this.loading = false
			this.end = true
			if (this.elem.childElementCount === 0) {
				const errorElem = document.createElement('p')
				errorElem.classList.add('empty-results-error')
				errorElem.innerHTML = 'No images found :('
				this.elem.appendChild(errorElem)
			}
		}
	}

	async filter(options) {
		// Retain sort (we're unifying filtering and sorting because of the restore-from-url feature that was added after the fact)
		const sort = this.filters.sort
		this.filters = options
		this.end = false
		let oldNodes = this.elem.querySelectorAll('.gallery_item, p')
		this.page = 0
		for (const node of oldNodes) {
			node.remove()
		}
		await this.loadNextPage(true)
		window.macy.recalculate(true)
		this.updateUrl()
	}

	updateUrl() {
		let url;
		if(window.location.href.includes('/gallery')) {
			url = window.tiaHost + '/gallery';
		} else {
			url = window.tiaHost + '/shortlist';
		}
		for (const key of Object.keys(this.filters)) {
			const value = this.filters[key]
			if (value) {
				if(value.length > 0 && Array.isArray(value)) {
					url += `/${key}:${value.join(',').replaceAll(' ', '-')}`
				} else if (value.length > 0) {
					url += `/${key}:${value.replaceAll(' ', '-')}`
				}
			}
		}
		window.history.pushState({}, null, url)
	}

	updateFiltersFromUrl() {
		let path = window.location.href.split(window.tiaHost+'/')[1] + '/';
		let url = location.href.slice(location.href.indexOf(path) + 8);
		let pairs = url.split('/')
		let filters = {};
 		for (const pair of pairs) {
			let parts = pair.split(':')
			if (parts[1]) {
				this.filters[parts[0]] = parts[1].replaceAll('-', ' ').split(',')
			}
		}
		// Push the results down to AlpineJS which then populates them back up using the filter() and sort() functions
		window.dispatchEvent(new CustomEvent('filterupdate', {detail: this.filters}))
	}

	async search(query) {
		if (query === 'Search' || query === 'Search') {
			query = false;
		}
		this.filters = { search: query}
		this.end = false
		let oldNodes = this.elem.querySelectorAll('.gallery_item, p')
		this.page = 0
		for (const node of oldNodes) {
			node.remove()
		}
		await this.loadNextPage(true)
		window.macy.recalculate(true)
	}
}
